import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import jsDig from "utils/jsDig";
import { RouterContext } from "./Onboarding";

export default function GoogleAnalyticsGoalTracking(props) {
  let labels = jsDig(["google_analytics", "account_ids"], props.seo_section.platform_data)
    ? jsDig(["google_analytics", "account_ids"], props.seo_section.platform_data)
    : [];

  const [selectedLabel, setSelectedLabel] = useState(labels[0] ? labels[0].id : null);
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();

  const addNewRow = () => {
    //create an object with all of the state fields
    let newRow = {};
    newRow.label = "";
    newRow.enabled = "0";
    newRow.goal = "1";
    let newObject = props.customAnalyticGoals;

    newObject[`${selectedLabel}`] = newObject[`${selectedLabel}`] ? [...newObject[`${selectedLabel}`], newRow] : [newRow];
    props.setCustomAnalyticaGoals({ ...newObject });
  };

  const removeRow = (id) => {
    let newObject = props.customAnalyticGoals;
    newObject[`${selectedLabel}`].splice(id, 1);
    props.setCustomAnalyticaGoals({ ...newObject });
  };

  const setupBox = (data, idx) => {
    return (
      <tr>
        <td>
          <CustomFormCheck
            checked={data.enabled == "1"}
            id={`ob-goal-tracking-${idx}`}
            onChange={(e) => {
              let newObject = props.customAnalyticGoals;
              newObject[`${selectedLabel}`][idx]["enabled"] = newObject[`${selectedLabel}`][idx]["enabled"] == "1" ? "0" : "1";
              props.setCustomAnalyticaGoals({ ...newObject });
            }}
          />
        </td>
        <td>
          <Form.Control
            // name={`[custom_analytics_goals][${label}][${idx}][goal]`}
            as="select"
            className="ml-0 primary d-inline-block"
            style={{ width: "116px" }}
            size="sm"
            value={data.goal}
            onChange={(e) => {
              let newObject = props.customAnalyticGoals;
              newObject[`${selectedLabel}`][idx]["goal"] = e.target.value;
              props.setCustomAnalyticaGoals({ ...newObject });
            }}>
            <option value="" hidden disabled>
              Choose one
            </option>
            {[...Array(20)].map((e, i) => {
              let goalNumber = i + 1;
              return (
                <option key={goalNumber} value={goalNumber}>
                  Goal {goalNumber}
                </option>
              );
            })}
          </Form.Control>
        </td>
        <td>
          <Form.Control
            // name={`[custom_analytics_goals][${label}][${idx}][label]`}
            size="sm"
            style={{ width: "211px" }}
            value={data.label}
            onChange={(e) => {
              let newObject = props.customAnalyticGoals;
              newObject[`${selectedLabel}`][idx]["label"] = e.target.value;
              props.setCustomAnalyticaGoals({ ...newObject });
            }}
            id={`ob-goal-tracking-id-${idx}`}
          />
        </td>
        <td>
          <i onClick={() => removeRow(idx)} className="fas fa-minus-circle color-danger"></i>
        </td>
      </tr>
    );
  };

  const infoText = () => {
    if (props.client_account.account_type == "ecommerce") {
      return `${props.company_name} is an ecommerce client. This step is optional.`;
    } else {
      return `${props.company_name} is a lead-gen client. If you do not select goals to track, then DataPulse will not pull any. This step is highly recommended!`;
    }
  }

  return (
    <>
      <Row className="px-lg-4 px-0 mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Google Analytics Goal Tracking</p>
          </div>
          <div>
            <p className="f14 nunito-regular primary ">
              Here you can specify which goals should be pulled from Analytics and counted towards conversions in DataPulse for this client. The 'Label' field may be used to describe the goal, just like in Analytics.
            </p>
            <p className="f16 nunito-bold text-center pt-3">
              {infoText()}
            </p>
          </div>
        </Col>
      </Row>

      <Row className="mb-5 mt-4 mx-lg-5 mx-0 justify-content-around">
        <Col md={5} className="p-0">
          <Row>
            <Col className="mr-0 pr-5 offset-md-1">
              <p className="visby-bold pb-2 light-primary f14">Provide the information below:</p>
            </Col>
          </Row>
          <Row className="py-2">
            <Col className="offset-md-1">
              <CustomFormCheck
                checked={props.customAnalyticGoalsEnabled}
                id="onboarding-google-analytics-tracking"
                onChange={() => props.setCustomAnalyticaGoalsEnabled(!props.customAnalyticGoalsEnabled)}
                label="Track goals from Google Analytics"
              />
            </Col>
            <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
          </Row>
          {props.customAnalyticGoalsEnabled && (
            <>
              <Row className="mt-2 mb-5">
                <Col className="offset-md-1">
                  <p className="f16 pr-3 d-inline-block primary">Select label/ID</p>
                  <Form.Control
                    as="select"
                    className="ml-0 primary d-inline-block"
                    style={{ width: "294px" }}
                    size="sm"
                    value={selectedLabel ? selectedLabel : undefined}
                    onChange={(e) => setSelectedLabel(e.target.value)}>
                    {labels.map((data) => (
                      <option value={data.id ? data.id : undefined} key={data.id}>
                        {data.label === undefined ? `- ${data.id}` : `${data.label} - ${data.id}`}
                      </option>
                    ))}
                  </Form.Control>
                </Col>
              </Row>
              {props.customAnalyticGoals[`${selectedLabel}`]
                ? (
                    <div className="table-responsive tracking-box">
                      <Table>
                        <tbody>
                          {props.customAnalyticGoals[`${selectedLabel}`].map((row, idx) => {
                            return <div key={idx}>{setupBox(row, idx)}</div>;
                          })}
                        </tbody>
                      </Table>
                    </div>
                  )
                : <></>
              }
              <Row className="mt-2 justify-content-center mb-5">
                <Col className="offset-md-0 text-center text-md-left" md={11}>
                  <Button
                    className="mt-3 mb-1 btn-sm add-analytics-goal"
                    style={{ paddingLeft: "39px", paddingRight: "39px" }}
                    size="sm"
                    as="input"
                    type="button"
                    onClick={() => addNewRow()}
                    value="+ Add goal"
                    variant="success"
                  />
                </Col>
              </Row>
            </>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton routes={props.routes} />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={true}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
